import { CopyToClipboardText } from "@/blocks/CopyToClipboardText";
import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

const MOCK_CALL_UUID = "3f29c1a4-7b2e-4d6a-9c8f-1e0d5b6a7c4f";

export function PlaygroundSectionCallUuid() {
  return (
    <Section data-test="call-uuid-section">
      <SectionHeader>
        <SectionTitle>Call UUID</SectionTitle>
      </SectionHeader>
      <CopyToClipboardText variant="filled">
        {MOCK_CALL_UUID}
      </CopyToClipboardText>
    </Section>
  );
}
